/* unplugin-vue-components disabled */import script from "./AvatarSelector-Horizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarSelector-Horizontal.vue?vue&type=script&setup=true&lang=js"

import "./AvatarSelector-Horizontal.vue?vue&type=style&index=0&id=64c2a505&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c2a505"]])

export default __exports__